export enum ComplicatedRequestTarget {
  COMPANIES = 'COMPANIES',
  CONTACTS = 'CONTACTS',
  CV = 'CV',
  EXPERIENCE = 'EXPERIENCE',
  EVERYWHERE = 'EVERYWHERE',
  LOCATION = 'LOCATION',
  MAIN_SKILL = 'MAIN_SKILL',
  NAME = 'NAME',
  PROJECTS = 'PROJECTS',
  RELATED_SKILLS = 'RELATED_SKILLS',
  TITLE = 'TITLE',
}

export interface ContactsQuery {
  emails: string[];
  phones: string[];
  telegrams: string[];
  links: string[];
}

export interface ComplicatedRequestObject {
  skills?: number[];
  skillsExceptions?: number[];
  tags?: number[];
  tagsExceptions?: number[];
  keywords?: string[];
  keywordsExceptions?: string[];
  target?: ComplicatedRequestTarget;
}

export interface CandidatesSearchQuery {
  keyword?: string;
  tagId?: number;
  bidStatusType?: string;
  bidStatusId?: number;
  bidSourceId?: number;
  bidAuthorId?: number;
  bidRejectReasonId?: number;
  hasEmail?: boolean;
  hasPhone?: boolean;
  bidCreatedFrom?: string;
  bidCreatedTo?: string;
  sortDirection?: string;
  sortField?: string;
  pageNumber?: number;
  pageSize?: number;
}

export interface ProfilesSearchQuery {
  addedBy?: number[];
  candidateStage?: number[];
  confirmed?: boolean;
  complicatedRequest?: ComplicatedRequestObject[];
  cities?: number[];
  cityTarget?: ComplicatedRequestTarget;
  countryId?: number;
  countries?: number[];
  countriesExceptions?: number[];
  employments?: number[];
  englishLevel?: number;
  allowSearchInForbiddenCountries?: boolean;
  excludeProcessedCandidates?: boolean;
  excludeWatchedCandidates?: boolean;
  excludedCandidates?: number[];
  event?: string;
  hadContract?: boolean;
  hasCV?: boolean;
  hasEmail?: boolean;
  hasPhone?: boolean;
  ids?: number[];
  keywords?: string[];
  lookingJob?: boolean;
  pageNumber?: number;
  pageSize?: number;
  rate?: string[];
  recruiters?: number[];
  rejectReason?: number[];
  remoteWork?: boolean;
  queryParamsString?: string;
  showToClient?: boolean;
  specialities?: number[];
  specialitiesExceptions?: number[];
  specialityTarget?: ComplicatedRequestTarget;
  sortDirection?: string;
  sortField?: string;
  sources?: number[];
  sourcesExceptions?: number[];
  vacancy?: number;
}
